// extracted by mini-css-extract-plugin
export default {"querySuggestionsContainer":"QuerySuggestions_querySuggestionsContainer__XT8ge","isMobile":"QuerySuggestions_isMobile__-U0T4"};